import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 20vw;
  height: 4rem;
  padding: 0.5rem 1.5rem;
  margin-bottom: 2.5rem;
  border: none;
  border-radius: 2rem;
  background-color: ${(props) => props.background};

  P {
    font-weight: 700;
    margin: auto 0;
    color: ${(props) => props.color};
  }

  &:hover {
    filter: brightness(1.1);
  }

  @media (max-width: 1023px) {
    width: 90vw;
  }
`;

const SubmitButton = ({ label, isLoading, type, onClick }) => {
  const { fontSizeMultiplier } = useConfigs();
  const { colorSecundario, backgroundWhite } = useThemes();

  return (
    <Button
      background={colorSecundario}
      color={backgroundWhite}
      type={type}
      onClick={onClick}
    >
      <div style={{ width: 25 * fontSizeMultiplier }}></div>
      <p style={{ fontSize: 15 * fontSizeMultiplier }}>
        {isLoading ? "Cargando" : label}
      </p>
      {isLoading ? (
        <Spinner animation="border" variant="light" />
      ) : (
        <FontAwesomeIcon
          icon={faArrowRightLong}
          color={backgroundWhite}
          size="lg"
        />
      )}
    </Button>
  );
};

export default SubmitButton;

SubmitButton.propTypes = {
  label: PropTypes.string,
  isLoading: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
};

SubmitButton.defaultProps = {
  isLoading: false,
  type: "submit",
  onClick: () => {},
};
